import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { BrandMark } from "@/components/Navbar";
import { GoogleButton } from "@/components/GoogleButton";

export default function Signup() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { signup } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password must be 6+ characters");
    setBusy(true);
    try {
      await signup(email, password, name);
      toast.success("Welcome to CLING");
      nav("/onboarding");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Signup failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen warm-grain grid place-items-center px-4">
      <div className="w-full max-w-md rise-in">
        <div className="flex justify-center mb-6"><BrandMark size={36} /></div>
        <div className="border rounded-3xl bg-card p-8 shadow-lg">
          <h1 className="font-display font-bold text-2xl">Join CLING</h1>
          <p className="text-sm text-muted-foreground mt-1">Real people. Real help. AI when you want it.</p>

          <div className="mt-6"><GoogleButton /></div>

          <div className="my-6 flex items-center gap-3 text-xs text-muted-foreground">
            <div className="h-px flex-1 bg-border" /> OR <div className="h-px flex-1 bg-border" />
          </div>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label>Your name</Label>
              <Input required value={name} onChange={(e) => setName(e.target.value)} data-testid="signup-name" />
            </div>
            <div>
              <Label>Email</Label>
              <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="signup-email" />
            </div>
            <div>
              <Label>Password</Label>
              <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="signup-password" />
            </div>
            <Button type="submit" className="w-full btn-teal h-11" disabled={busy} data-testid="signup-submit">
              {busy ? "Creating..." : "Create my CLING account"}
            </Button>
          </form>

          <p className="mt-6 text-sm text-muted-foreground text-center">
            Already here? <Link to="/login" className="text-[color:hsl(var(--teal))] font-medium">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
